import * as yup from "yup";

/**
 * Prvi korak naloga. Servis i naziv su obavezni i na backendu — nalog bez servisera nema
 * smisla, a bez naziva se ne razlikuje od drugih naloga istog vozila.
 */
export const FLEET_VEHICLE_SERVICE_EDIT_FORM_SCHEMA = yup.object().shape({
  contactId: yup.string().nullable().required("Odaberite servis"),

  name: yup
    .string()
    .nullable()
    .trim()
    .required("Naziv naloga je obavezan podatak"),

  receivedDate: yup
    .date()
    .nullable()
    .required("Datum zaprimanja je obavezan podatak"),
});
